import React from 'react';

import EdgeCrm from './edge_crm';
import LiteCrm from './lite_crm';

import type { Props as BaseProps } from './types';

interface Props extends BaseProps {
  edgeCrm?: boolean;
}

export default function MapListHeaderLiteCrm({ edgeCrm, ...props }: Props) {
  const Component = edgeCrm ? EdgeCrm : LiteCrm;
  return <Component {...props} />;
}
